export default __webpack_public_path__ + "static/media/Final Aum Jewellery logo.97f583ac.jpg";